import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { PageContent } from "../../components/PageContent/PageContent";
import { strings } from "../../config/string";
import { DocumentDetailsContainer } from "./DocumentDetailsContainer/DocumentDetailsContainer";
import { ProjectSummary } from "./ProjectSummary/ProjectSummary";
import { useGetDocumentDetailsByProject } from "../../services/documentService";

export const DocumentDetailsPage = () => {
  const location = useLocation();
  const [projectId, setProjectId] = useState<string | undefined>();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const id = params.get("projectId");
    setProjectId(id || undefined);
  }, [location]);

  const { data, isLoading } = useGetDocumentDetailsByProject(projectId);

  if (!projectId) {
    return <div>Project ID is required</div>;
  }

  return (
    <PageContent title={strings.documentDetailsPage}>
      <ProjectSummary projectId={projectId} />
      
      {isLoading ? (
        <div className="d-flex align-items-center gap-2 p-3 bg-light rounded-3">
          <div className="spinner-border spinner-border-sm text-primary" role="status">
            <span className="visually-hidden">Loading documents...</span>
          </div>
          <span>Loading documents...</span>
        </div>
      ) : (
        <DocumentDetailsContainer documents={data || []} projectId={projectId} />
      )}
    </PageContent>
  );
};